export const DEFAULT_DATA_TABLE_PAGE_SIZE = 20;

export const DATA_TABLE_ROWS_PER_PAGE_OPTIONS = [
  DEFAULT_DATA_TABLE_PAGE_SIZE,
  50,
  100,
];
